import { createSlice } from '@reduxjs/toolkit'
$ = jQuery

const clinics = $('#clinic_location_map')
    .data('other-clinics')
    .map((clinic) => ({
        ...clinic,
        location: JSON.parse(clinic.location),
    }))

console.log('clinics:', clinics)

let current_clinic = $('#clinic_location_map').data('current-clinic')
console.log('current_clinic:', current_clinic)
if (current_clinic && current_clinic.location) {
    current_clinic = {
        ...current_clinic,
        location: JSON.parse(current_clinic.location),
    }
}

const clinicsSlice = createSlice({
    name: 'clinics',
    initialState: {
        clinics,
        currentClinic: current_clinic,
    },
    reducers: {
        setClinics: (state, action) => {
            state.clinics = action.payload
        },
        setCurrentClinic: (state, action) => {
            state.currentClinic = action.payload
        },
        setCurrentClinicLocation: (state, action) => {
            state.currentClinic.location = action.payload
        },
        setCurrentClinicTitle: (state, action) => {
            state.currentClinic.title = action.payload
        },
        setCurrentClinicExcerpt: (state, action) => {
            state.currentClinic.excerpt = action.payload
        },
        setCurrentClinicThumbnail: (state, action) => {
            state.currentClinic.thumbnail = action.payload
        },
    },
})

export const {
    setClinics,
    setCurrentClinic,
    setCurrentClinicLocation,
    setCurrentClinicTitle,
    setCurrentClinicExcerpt,
    setCurrentClinicThumbnail,
} = clinicsSlice.actions

export default clinicsSlice.reducer
